import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import Stories from './pages/Stories';
import Story from './pages/Story';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter, Route, Routes } from "react-router-dom";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
      <BrowserRouter>
       <Routes>
        <Route path="/" element={ <App/> } />
        <Route path="/stories" element={ <Stories/> } />
        <Route path="/story/:storyShortName" action={({ params }) => {}} element={ <Story /> } />
      </Routes>
      </BrowserRouter>,
    );

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();